// extracted by mini-css-extract-plugin
export default {"itemList":"W7DV87","item":"Ih33bv"};